"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { ApiWaveType } from "@/generated/models/ApiWaveType";
import type { CreateWaveDatesConfig } from "@/types/waves.types";
import CreateWaveWarning from "../utils/CreateWaveWarning";
export default function CreateWaveOutcomeWarning(t0) {
  const $ = _c(8);
  const {
    waveType,
    dates,
    maxWinners
  } = t0;
  const isApproveWave = waveType === ApiWaveType.Approve;
  const [warning, setWarning] = useState(null);
  let t1;
  let t2;
  if ($[0] !== dates.endDate || $[1] !== isApproveWave || $[2] !== maxWinners) {
    t1 = () => {
      if (!isApproveWave) {
        setWarning(null);
        return;
      }
      if (maxWinners) {
        setWarning(null);
        return;
      }
      if (!dates.endDate) {
        setWarning({
          title: "Warning: Challenge Will Run Indefinitely",
          description: "You have not set an end date or a maximum number of winners for this challenge. It will run indefinitely, and everyone who meets the threshold will be awarded."
        });
        return;
      }
      setWarning({
        title: "Warning: Unlimited Awards",
        description: "You have not set a maximum number of winners for this challenge. Everyone who meets the threshold will be awarded."
      });
    };
    t2 = [dates.endDate, maxWinners, isApproveWave];
    $[0] = dates.endDate;
    $[1] = isApproveWave;
    $[2] = maxWinners;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  if (!warning) {
    return null;
  }
  let t3;
  if ($[5] !== warning.description || $[6] !== warning.title) {
    t3 = <CreateWaveWarning title={warning.title} description={warning.description} />;
    $[5] = warning.description;
    $[6] = warning.title;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}